document.addEventListener("DOMContentLoaded", function () {

  const modelSelect   = document.getElementById("wc_model");
  const flavourSelect = document.getElementById("wc_flavour");
  const stampRadios   = document.querySelectorAll("input[name='contact[excise_stamp]']");
  const phoneInput    = document.getElementById("wc_phone");

  if (!modelSelect || !flavourSelect) return;

  function getStampCode() {
    const checked = document.querySelector("input[name='contact[excise_stamp]']:checked");
    if (!checked) return "";
    const value = checked.value.toLowerCase();
    if (value.includes("alberta"))      return "AB";
    if (value.includes("manitoba"))     return "MB";
    if (value.includes("new brunswick")) return "NB";
    if (value.includes("ontario"))      return "ON";
    if (value.includes("fed"))          return "FED";
    return "";
  }

  function resetFlavour(message) {
    flavourSelect.innerHTML = "";
    const option = document.createElement("option");
    option.value = "";
    option.textContent = message;
    flavourSelect.appendChild(option);
    flavourSelect.disabled = true;
  }

  function cleanFlavourName(item) {
    let name = (item.title || "").trim();
    if (!name || name.toLowerCase() === "default title") {
      name = (item.product_title || "").trim();
    }
    return name;
  }

  function populateFlavours() {
    const model   = modelSelect.value;
    const stamp   = getStampCode();
    const items   = (window.NashaWarrantyFlavours || {})[model] || [];

    if (!model)  { resetFlavour("Select Model First");      return; }
    if (!stamp)  { resetFlavour("Select Stamp First");      return; }

    const filtered = items.filter(item => item.stamp === stamp);
    if (!filtered.length) { resetFlavour("No flavours available"); return; }

    flavourSelect.innerHTML = "";
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Please Select";
    flavourSelect.appendChild(defaultOption);

    const seen = new Set();
    filtered.forEach(function (item) {
      const name = cleanFlavourName(item);
      if (!name || seen.has(name.toLowerCase())) return;
      seen.add(name.toLowerCase());
      const option = document.createElement("option");
      option.value = name;
      option.textContent = name;
      flavourSelect.appendChild(option);
    });

    flavourSelect.disabled = false;
    updateSelectColor(flavourSelect);
  }

  // Force dark background on all selects
  function updateSelectColor(select) {
    select.style.setProperty('background', '#000000', 'important');
    select.style.setProperty('color',
      select.value === '' ? 'rgba(255,255,255,0.40)' : 'rgba(255,255,255,0.90)',
      'important'
    );
  }
  // Custom dropdown builder (same style as store dropdown)
function buildCustomDropdown(selectEl) {
  const wrapper = selectEl.closest('.nasha-warranty-form__field');
  if (!wrapper || wrapper.dataset.customDropdown) return;
  wrapper.dataset.customDropdown = 'true';
  wrapper.style.position = 'relative';

  // Build display button (replaces the select visually)
  const display = document.createElement('div');
  display.className = 'nasha-custom-dropdown__display';
  display.dataset.for = selectEl.id;

  function syncDisplay() {
    const selected = selectEl.options[selectEl.selectedIndex];
    display.textContent = selected ? selected.text : '';
    display.style.color = (!selectEl.value || selectEl.value === '')
      ? 'rgba(255,255,255,0.40)'
      : 'rgba(255,255,255,0.90)';
  }
  syncDisplay();

  // Build dropdown list
  const dropdownEl = document.createElement('div');
  dropdownEl.className = 'nasha-warranty-form__storeDropdown hidden';

  function buildOptions() {
    dropdownEl.innerHTML = '';
    Array.from(selectEl.options).forEach(function (opt) {
      const item = document.createElement('div');
      item.className = 'nasha-warranty-form__storeOption';
      item.innerHTML = `<span class="nasha-warranty-form__storeName">${opt.text}</span>`;
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change'));
        syncDisplay();
        dropdownEl.classList.add('hidden');
      });
      dropdownEl.appendChild(item);
    });
  }
  buildOptions();

  // Toggle open/close
  display.addEventListener('click', function (e) {
    e.stopPropagation();
    const isHidden = dropdownEl.classList.contains('hidden');
    // Close all other dropdowns first
    document.querySelectorAll('.nasha-warranty-form__storeDropdown').forEach(d => d.classList.add('hidden'));
    if (isHidden) dropdownEl.classList.remove('hidden');
  });

  // Close on outside click
  document.addEventListener('click', function () {
    dropdownEl.classList.add('hidden');
  });

  // Watch for option changes (e.g. flavour gets repopulated)
  const observer = new MutationObserver(function () {
    buildOptions();
    syncDisplay();
  });
  observer.observe(selectEl, { childList: true });

  // Hide native select, insert custom elements
  selectEl.style.display = 'none';
  wrapper.insertBefore(display, selectEl);
  wrapper.appendChild(dropdownEl);

  // Keep select in sync for form submission
  selectEl.addEventListener('change', function () {
    syncDisplay();
    buildOptions();
  });
}

// Apply to all selects except store (which already has custom dropdown)
document.querySelectorAll('.nasha-warranty-form__field select').forEach(function (select) {
  if (select.id !== 'wc_store') {
    buildCustomDropdown(select);
  }
});

  document.querySelectorAll('.nasha-warranty-form__field select').forEach(function (select) {
    updateSelectColor(select);
    select.addEventListener('change', function () { updateSelectColor(select); });
  });

  // Events
  modelSelect.addEventListener("change", populateFlavours);
  stampRadios.forEach(radio => radio.addEventListener("change", populateFlavours));
  resetFlavour("Select Stamp and Model First");

  // Phone formatting
  if (phoneInput) {
    phoneInput.addEventListener("input", function (e) {
      let n = e.target.value.replace(/\D/g, "").substring(0, 10);
      let f = "";
      if (n.length > 0) f += "(" + n.substring(0, 3);
      if (n.length >= 4) f += ")-" + n.substring(3, 6);
      if (n.length >= 7) f += "-" + n.substring(6, 10);
      e.target.value = f;
    });
  }

});